import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { OfferCountdown } from './OfferCountdown';
import { checkoutUrl, originalPrice, price } from '../data/kit';
import { buildCheckoutUrl, handleCheckoutClick } from '../utils/checkout';
export function MobileStickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const offer = document.getElementById('oferta');
      const pastHero = window.scrollY > 700;
      let inOffer = false;
      if (offer) {
        const rect = offer.getBoundingClientRect();
        inOffer = rect.top < window.innerHeight && rect.bottom > 0;
      }
      setVisible(pastHero && !inOffer);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-204" data-mp="156vb4y771f9q">
      {visible && <motion.div initial={{
      y: '100%',
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: '100%',
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-surface px-4 py-3 md:hidden" data-id="element-205" data-mp="157wpbbjiahvo">
          <div className="flex items-center justify-between gap-3" data-id="element-206" data-mp="1wd2edactojz7">
            <div data-id="element-207" data-mp="1wex2exje4s7i">
              <p className="flex items-baseline gap-2" data-id="element-208" data-mp="2u0ky1g80v6hz">
                <span className="font-display text-xl font-black leading-none text-brand" data-id="element-209" data-mp="2u01fpyegmg3f">{price} ARS</span>
                <span className="text-xs text-muted line-through" data-id="element-210" data-mp="2p1zup7xh46pb">{originalPrice}</span>
              </p>
              <OfferCountdown variant="inline" data-id="element-211" data-mp="2k8x335c9b7br" />
            </div>
            <a href={buildCheckoutUrl(checkoutUrl)} onClick={handleCheckoutClick} className="whitespace-nowrap rounded-full bg-cta px-5 py-3 font-display text-sm font-extrabold uppercase text-cta-ink transition-colors duration-150 ease-out hover:bg-cta-hover" data-id="element-212" data-mp="2fan5yp6z1wni">
              Quiero el kit
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}